import React from 'react';
import ReactDOMServer from 'react-dom/server';
import { sum, round } from 'lodash';

import { grandTotal } from '../../utils/chart/ChartManagementFeatures/showChartFeatures';

const getRoundedPercentString = (percentage) => `${Math.round(percentage * 100) / 100}%`;

const calcPercent = (num, total) => (num * 100) / total;

const TooltipGrandTotal = (isSplit, { series, key, y, percentage, total }, isPaying) => {
  const grandTotalVal = series.data.find((s) => String(s.name) === grandTotal).total;
  const sumSelectedSeries = sum(series.processedYData.slice(0, -1));

  return ReactDOMServer.renderToStaticMarkup(
    isSplit ? (
      <div>
        <div className="tooltip-bold">{key}</div>
        <div>{series.name}</div>
        <div>
          Value: <span className="tooltip-bold">{`${round(y, 2)}${isPaying ? '%' : ''}`}</span>
        </div>
        <div>
          is: <span className="tooltip-bold">{getRoundedPercentString(percentage)}</span> of
        </div>
        <div>
          {key} of:{' '}
          <span className="tooltip-bold">{`${round(total, 2)}${isPaying ? '%' : ''}`}</span>
        </div>
        <div>
          and:{' '}
          <span className="tooltip-bold">
            {getRoundedPercentString(calcPercent(y, sumSelectedSeries))}
          </span>{' '}
          of
        </div>
        <div>
          Total of {series.name} of:{' '}
          <span className="tooltip-bold">
            {`${round(sumSelectedSeries, 2)}${isPaying ? '%' : ''}`}
          </span>
        </div>
        <div>
          and:{' '}
          <span className="tooltip-bold">
            {getRoundedPercentString(calcPercent(y, grandTotalVal))}
          </span>{' '}
          of
        </div>
        <div>
          {grandTotal} of:{' '}
          <span className="tooltip-bold">{`${round(grandTotalVal, 2)}${isPaying ? '%' : ''}`}</span>
        </div>
      </div>
    ) : (
      <div>
        <div className="tooltip-bold">{key}</div>
        <div>
          Value: <span className="tooltip-bold">{`${round(y, 2)}${isPaying ? '%' : ''}`}</span>
        </div>
        <div>
          is:{' '}
          <span className="tooltip-bold">
            {getRoundedPercentString(calcPercent(y, grandTotalVal))}
          </span>{' '}
          of
        </div>
        <div>
          {grandTotal} of:{' '}
          <span className="tooltip-bold">{`${round(grandTotalVal, 2)}${isPaying ? '%' : ''}`}</span>
        </div>
      </div>
    )
  );
};

const Tooltip = (isSplit, { series, key, y, percentage, total }, isPaying) =>
  ReactDOMServer.renderToStaticMarkup(
    isSplit ? (
      <div>
        <div className="tooltip-bold">{key}</div>
        <div>{series.name}</div>
        <div>
          Value: <span className="tooltip-bold">{`${round(y, 2)}${isPaying ? '%' : ''}`}</span>
        </div>
        <div>
          is: <span className="tooltip-bold">{getRoundedPercentString(percentage)}</span> of
        </div>
        <div>
          {key} of:{' '}
          <span className="tooltip-bold">{`${round(total, 2)}${isPaying ? '%' : ''}`}</span>
        </div>
      </div>
    ) : (
      <div>
        <div className="tooltip-bold">{key}</div>
        <div>
          Value: <span className="tooltip-bold">{`${round(y, 2)}${isPaying ? '%' : ''}`}</span>
        </div>
      </div>
    )
  );

const ColumnChartTooltip = (isSplit, isGrandTotal, chart, isPaying) =>
  isGrandTotal ? TooltipGrandTotal(isSplit, chart, isPaying) : Tooltip(isSplit, chart, isPaying);

export default ColumnChartTooltip;
